import store from '@/store';
import NxAuthUserPasswordLoginButton
  from '@/modules/authentication/components/alternative-login-methods/AuthUserPasswordLoginButton.vue';
import NxAuthGoogleLoginButton
  from '@/modules/authentication/components/alternative-login-methods/AuthGoogleLoginButton.vue';

export interface LoginMethod {
  id: String;
  component: Object;
  drawerPosition: number;
  enabled?: () => void;
}

export const loginMethods: LoginMethod[] = [
  {
    id: 'user-password-login',
    component: NxAuthUserPasswordLoginButton,
    drawerPosition: 10, // High number so other methods can be positioned before this.
  },
  {
    id: 'google-login',
    component: NxAuthGoogleLoginButton,
    drawerPosition: 20, // High number so other methods can be positioned before this.
    enabled() {
      return store.getters.oAuthEnabled;
    },
  },
];
export const registerLoginMethod = (loginMethod: LoginMethod) => {
  loginMethods.push(loginMethod);
};
